import { partsRegisterListQuerySchema } from '@chukua/common';
import { PartsRegisterTable } from '../components/PartsRegisterTable';
import { listPartsRegister } from '../parts.api';

/** The parts fitted register (gitaumoses4/chukua#174): every part fitted on any truck, from the effective parts lines of work orders that have started. Parts are recorded on the work order. */
export function PartsPage() {
  return (
    <PartsRegisterTable
      schema={partsRegisterListQuerySchema}
      fetchPage={listPartsRegister}
      showTruck
      emptyDescription="Parts recorded on a work order that is under way or done appear here, with the truck, odometer, supplier and work order."
      searchPlaceholder="Search part, serial, work order, supplier or truck"
    />
  );
}
